"use strict";

var _classCallCheck = require("/home/abhishek/Documents/Macrometa/demos/tutorial-cryptotrading/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/abhishek/Documents/Macrometa/demos/tutorial-cryptotrading/crypto-demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var helper_1 = require("./util/helper");

var query_string_1 = require("query-string"); // 2 document
// 3 edge
// 4 persistent


var webSocket_1 = require("./util/webSocket");

var StreamConstants;

(function (StreamConstants) {
  StreamConstants["PERSISTENT"] = "persistent";
})(StreamConstants = exports.StreamConstants || (exports.StreamConstants = {}));

var Stream = /*#__PURE__*/function () {
  function Stream(connection, name) {
    var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isCollectionStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, Stream);

    this._connection = connection;
    this.isCollectionStream = isCollectionStream;
    /**
     * CHANGED this.local implementation to this.global
     * keeping the stream as local so !local
     */

    this.global = !local;
    this.name = name;
    var topic = this.name;

    if (!this.isCollectionStream) {
      if (this.global) topic = "c8globals.".concat(this.name);else topic = "c8locals.".concat(this.name);
    }

    this.topic = topic;
  }

  _createClass(Stream, [{
    key: "_getPath",
    value: function _getPath(useName, urlSuffix) {
      var topic = useName ? this.name : this.topic;
      return helper_1.getFullStreamPath(topic, urlSuffix);
    }
  }, {
    key: "getOtp",
    value: function getOtp() {
      return this._connection.request({
        method: "POST",
        path: "/apid/otp",
        absolutePath: true
      }, function (res) {
        return res.body.otp;
      });
    }
  }, {
    key: "createStream",
    value: function createStream() {
      return this._connection.request({
        method: "POST",
        path: this._getPath(true),
        qs: "global=".concat(this.global)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "backlog",
    value: function backlog() {
      var urlSuffix = "/backlog";
      return this._connection.request({
        method: "GET",
        path: this._getPath(false, urlSuffix),
        qs: "global=".concat(this.global)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearBacklog",
    value: function clearBacklog() {
      var urlSuffix = "/clearbacklog";
      return this._connection.request({
        method: "POST",
        path: this._getPath(false, urlSuffix),
        qs: "global=".concat(this.global)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getStreamStatistics",
    value: function getStreamStatistics() {
      var urlSuffix = "/stats";
      return this._connection.request({
        method: "GET",
        path: this._getPath(false, urlSuffix),
        qs: "global=".concat(this.global)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "deleteSubscription",
    value: function deleteSubscription(subscription) {
      var urlSuffix = "/subscription/".concat(subscription);
      return this._connection.request({
        method: "DELETE",
        path: this._getPath(false, urlSuffix),
        qs: "global=".concat(this.global)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "expireMessages",
    value: function expireMessages(expireTimeInSeconds) {
      var urlSuffix = "/expiry/".concat(expireTimeInSeconds);
      return this._connection.request({
        method: "POST",
        path: this._getPath(false, urlSuffix),
        qs: "global=".concat(this.global)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "clearSubscriptionBacklog",
    value: function clearSubscriptionBacklog(subscription) {
      var urlSuffix = "/clearbacklog/".concat(subscription);
      return this._connection.request({
        method: "POST",
        path: this._getPath(false, urlSuffix),
        qs: "global=".concat(this.global)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getSubscriptionList",
    value: function getSubscriptionList() {
      var urlSuffix = "/subscriptions";
      return this._connection.request({
        method: "GET",
        path: this._getPath(false, urlSuffix),
        qs: "global=".concat(this.global)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "deleteStream",
    value: function deleteStream() {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return this._connection.request({
        method: "DELETE",
        path: this._getPath(false),
        qs: "global=".concat(this.global, "&force=").concat(force)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "consumer",
    value: function consumer(subscriptionName, dcName) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var lowerCaseUrl = dcName.toLocaleLowerCase();
      if (lowerCaseUrl.includes("http") || lowerCaseUrl.includes("https")) throw "Invalid DC name";
      var persist = StreamConstants.PERSISTENT;
      var region = this.global ? "c8global" : "c8local";

      var tenant = this._connection.getTenantName();

      var queryParams = query_string_1.stringify(params);

      var dbName = this._connection.getFabricName();

      if (!dbName || !tenant) throw "Set correct DB and/or tenant name before using.";
      var consumerUrl = "wss://api-".concat(dcName, "/_ws/ws/v2/consumer/").concat(persist, "/").concat(tenant, "/").concat(region, ".").concat(dbName, "/").concat(this.topic, "/").concat(subscriptionName); // Appending query params to the url

      consumerUrl = "".concat(consumerUrl, "?").concat(queryParams);
      return webSocket_1.ws(consumerUrl);
    }
  }, {
    key: "producer",
    value: function producer(dcName) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!dcName) throw "DC name not provided to establish producer connection";
      var lowerCaseUrl = dcName.toLocaleLowerCase();
      if (lowerCaseUrl.includes("http") || lowerCaseUrl.includes("https")) throw "Invalid DC name";
      var persist = StreamConstants.PERSISTENT;
      var region = this.global ? "c8global" : "c8local";

      var tenant = this._connection.getTenantName();

      var queryParams = query_string_1.stringify(params);

      var dbName = this._connection.getFabricName();

      if (!dbName || !tenant) throw "Set correct DB and/or tenant name before using.";
      var producerUrl = "wss://api-".concat(dcName, "/_ws/ws/v2/producer/").concat(persist, "/").concat(tenant, "/").concat(region, ".").concat(dbName, "/").concat(this.topic); // Appending query params to the url

      producerUrl = "".concat(producerUrl, "?").concat(queryParams);
      return webSocket_1.ws(producerUrl);
    }
  }, {
    key: "publishMessage",
    value: function publishMessage(message) {
      var urlSuffix = "/publish";
      return this._connection.request({
        method: "POST",
        path: this._getPath(false, urlSuffix),
        qs: "global=".concat(this.global),
        body: message
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getMessageTtl",
    value: function getMessageTtl() {
      return this._connection.request({
        method: "GET",
        path: "/_api/streams/ttl"
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "setMessageTtl",
    value: function setMessageTtl() {
      var ttl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3600;
      return this._connection.request({
        method: "POST",
        path: "/_api/streams/ttl/".concat(ttl)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "deleteSubscriptions",
    value: function deleteSubscriptions(subscription) {
      var urlSuffix = "/subscriptions/".concat(subscription);
      return this._connection.request({
        method: "DELETE",
        path: this._getPath(false, urlSuffix),
        qs: "global=".concat(this.global)
      }, function (res) {
        return res.body;
      });
    }
  }]);

  return Stream;
}();

exports.Stream = Stream;